"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutoLogout = void 0;
var _react = require("react");
var _shared = require("../shared");
var _ = require("./");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var idleTimer;
var idleSession;
var defaultConfig = {
  enabled: true,
  trackEvents: false,
  isAdmin: false
};
var useAutoLogout = function useAutoLogout(config) {
  var _defaultConfig$config = _objectSpread(_objectSpread({}, defaultConfig), config),
    enabled = _defaultConfig$config.enabled,
    customLogout = _defaultConfig$config.logout,
    isAdmin = _defaultConfig$config.isAdmin;
  var _useAuth = (0, _shared.useAuth)(),
    isAuthenticated = _useAuth.isAuthenticated,
    logout = _useAuth.logout,
    performIdlePing = _useAuth.performIdlePing;
  var _useSimulationMode = (0, _.useSimulationMode)(),
    isSimulationMode = _useSimulationMode.isSimulationMode;
  var sessionLifetime = isAdmin || isSimulationMode ? _.ADMIN_SESSION_LIFETIME : process.env.REACT_APP_SESSION_LIFETIME || _.SESSION_LIFETIME;
  var onTimeOut = (0, _react.useCallback)(function () {
    (customLogout || logout)();
  }, [logout, customLogout]);
  var initIdleSession = (0, _react.useCallback)(function () {
    dropIdleSession();
    idleSession = (0, _.idle)(sessionLifetime, onTimeOut);
    idleSession.start();
  }, [enabled, logout]);

  // this effect is required for custom logout function update
  (0, _react.useEffect)(function () {
    if (idleSession) {
      idleSession.onTimeOut = onTimeOut;
    }
  }, [idleSession, onTimeOut]);
  var initIdleInterval = (0, _react.useCallback)(function () {
    dropIdleInterval();
    idleTimer = setInterval(function () {
      if (sessionLifetime - idleSession.getTimeLeft() < _.IDLE_PING_FREQUENCY) {
        performIdlePing();
      }
    }, _.IDLE_PING_FREQUENCY);
  }, [enabled, logout]);
  var dropIdleSession = function dropIdleSession() {
    if (idleSession) {
      idleSession.dispose();
      idleSession = null;
    }
  };
  var dropIdleInterval = function dropIdleInterval() {
    if (idleTimer) {
      clearInterval(idleTimer);
      idleTimer = null;
    }
  };
  var startAutoLogoutSession = function startAutoLogoutSession() {
    initIdleSession();
    initIdleInterval();
  };
  var dropAutoLogoutSession = function dropAutoLogoutSession() {
    dropIdleSession();
    dropIdleInterval();
  };
  (0, _react.useEffect)(function () {
    if (!isAuthenticated) {
      return;
    }
    if (enabled) {
      startAutoLogoutSession();
    } else {
      dropAutoLogoutSession();
    }
  }, [isAuthenticated, enabled]);
};
exports.useAutoLogout = useAutoLogout;